module.exports = __webpack_public_path__ + "img/Logo_Sparkasse_rot.a95becbd.png";